<template>
    <div class="x-tablelist-view" data-automation="manageProduct">
      <div class="search-warp">
          <el-row type="flex" justify="start" :gutter="16">
           
            <el-col :span="4">
              <ux-select v-model="filter.mcType" clearable :options="allMctype" :props="{label:'name',value:'name'}" :placeholder="$t('HT.upgrade.mctype')"></ux-select>
            </el-col>
            <el-col :span="4">
              <ux-select v-model="filter.source" clearable :options="platform"  :props="{ label: 'name', value: 'name' }" :placeholder="$t('HT.advancedService.sourcePlatform')"></ux-select>
            </el-col>
            
               <el-col >
                  <el-button type="primary"  @click="seach"  size="small">{{
                      $t('HT.search')
                  }}</el-button>
                  <el-button plain @click="reset" size="small" >{{
                      $t('HT.reset')
                  }}</el-button>
              </el-col>
          </el-row>
        </div>
  
  
      <!-- 表格 -->
      <div class="x-table-box">
        <ux-table ref="table" :showPage="showPage" maxHeight="100%" :hide-on-single-page="true" :data="tableData.list"
          :columns="columns1" :total="tableData.totalSize" :size.sync="filter.size" :page.sync="filter.page"
          @changePage="changePage" @changeSize="changeSize" :emptyText="$t('HT.nodata')"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>
  </template>
    
  <script>
  import AddImeiInput from '@/components/AddImeiInput/index.vue';
  import  { strategyStatusFilter } from '@/filters';
  import {mapState,mapActions} from 'vuex'
  export default {
    components: {
      AddImeiInput
    },
    data() {
      return {
        userData: {}, // 登录者信息
        showPage: true,
        columns1: [
          // 表头数据
          {
            label: this.$t('HT.advancedService.mctypeModel'),
            tooltip: true,
            align: 'left',
            prop: 'mcType'
          },
          {
            label: this.$t('HT.advancedService.sourcePlatform'),
            prop: 'source',
            align: 'left',
            tooltip: true
          },
          {
            label: this.$t('HT.createdTime'),
            prop: 'createTime',
            align: 'left',
            tooltip: true,
          },
          {
            label: this.$t('HT.advancedService.deviceNumber'),
            prop: 'count',
            align: 'left',
            tooltip: true,
            render: (h, params) => {
              return h('my-table-btn', {
                props: {
                  data: [
                    params.count,
                  ],
                  className: [
                    '',
                    this.userData.supervisor && params.published != 2 ? '' : 'no-click',
                    params.published == 0 ? 'no-click' : '',
                    ''
                  ],
                  event: ['goToDetail']
                },
                on: {
                  // 管理
                  goToDetail: () => {
                    this.goToDetail(params);
                  },
  
                }
              });
            }
          },
          // mcType
        ],
        filter: {
          // 查询参数
          mcType: '',
          source: '',
          page: 1,
          size: 10
        },
        tableData: {
          // 表格数据
          totalSize: 0,
          list: []
        }
      };
    },
    created() {
      this.getPlatform();
      this.getAllMctype()
      this.getAllList();
      this.userData = this.$store.state.login.userData;
     
    },
    computed: {
      ...mapState('advancedService', ['platform','allMctype'])
    },
    methods: {
      ...mapActions('advancedService',['getPlatform','getAllMctype']),
     
  
      /**
       * 获取列表
       * @param {Object} params 请求参数
       */
      getAllList() {
        const params = Object.assign({}, this.filter);
        this.$uxLoading.show();
        this.$api.advancedService.mctypeList(params).then((res) => {
          if (res.code == 10000) {
            this.tableData = {
              totalSize: res.total_size,
              list: res.data
            };
          }
        });
      },
  
  
      /**
       * 搜索
       */
      seach() {
        this.filter.page = 1;
        this.getAllList();
      },
  
      /**
       * 改变页容量
       * @param {Number} size 选择的页容量
       */
      changeSize(size) {
        this.filter.size = size;
        this.filter.page = 1;
        this.getAllList();
      },
      /**
       * 改变页码
       * @param {Number} page 选择的页码
       */
      changePage(page) {
        this.filter.page = page;
        this.getAllList();
      },
      reset() {
        this.filter.mcType = '';
        this.filter.source = '';
        this.filter.page = 1;
        this.filter.size = 10;
        this.getAllList();
      },
      goToDetail({mcType}){
        this.$router.push(`/advancedService/device?mcType=${mcType}`)
      }
     
    }
  };
  </script>
    